export default "__VITE_ASSET__BaK6FlJh__"